/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { RequestBuilder } from '../../request-builder';
import { StrictHttpResponse } from '../../strict-http-response';

import { SearchPropertyByCouncilNoResultDto } from '../../models/search-property-by-council-no-result-dto';

export interface SearchForPropertyByCouncilPropertyNo$Params {
  property_number: string;

  /**
   * LGA code (3-digit number)
   */
  lga_code: string;
}

export function searchForPropertyByCouncilPropertyNo(
  http: HttpClient,
  rootUrl: string,
  params: SearchForPropertyByCouncilPropertyNo$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<SearchPropertyByCouncilNoResultDto>> {
  const rb = new RequestBuilder(
    rootUrl,
    searchForPropertyByCouncilPropertyNo.PATH,
    'get',
  );
  if (params) {
    rb.query('property_number', params.property_number, {});
    rb.query('lga_code', params.lga_code, {});
  }

  return http
    .request(
      rb.build({ responseType: 'json', accept: 'application/json', context }),
    )
    .pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<SearchPropertyByCouncilNoResultDto>;
      }),
    );
}

searchForPropertyByCouncilPropertyNo.PATH = '/search/property';
